import { StaffActivitiesByDescription } from "../../types";

export const staffActivities: StaffActivitiesByDescription = {
  "Hawaii Tier2 Submit": {
    parameters: {
      linkUrls: [
        "https://eha-cloud.doh.hawaii.gov/epermit/app/#/formversion/69d2957c-f95e-4384-b3c4-cab8f4594d46",
      ],
      staffInputs: {
        fees: true,
        documentTypes: {
          receipt: true,
          submission: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Tier2 Submit",
    state: "HI",
  },
};
